import React, {useEffect} from 'react';

import {useDispatch} from 'react-redux';

import {Cache} from 'aws-amplify';

import {Hub} from '@aws-amplify/core';

import {clearSelection} from 'features/accounts/reducers';

// import { fetchApplications } from 'features/applications/reducers/recordsSlice';
// import { fetchAccounts } from 'features/accounts/reducers/recordsSlice';
import AuthorizingIndicator from '../components/AuthorizingIndicator';

import {Navigate, useNavigate} from 'react-router-dom';

import {getWithEmail, update} from 'services/AccountsService';

export const IndexPage = () => {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(clearSelection());
        // dispatch(fetchApplications());
        // dispatch(fetchAccounts());
    }, [dispatch]);

    const onAuthEvent = (payload) => {
        switch (payload.event) {
            case 'signIn':
            case 'cognitoHostedUI':
                if (payload.data.signInUserSession !== null) {
                    console.debug(
                        'LOGIN APP. INDEX PAGE. PAYLOAD',
                        payload.data
                    );

                    let idTokenPayload =
                        payload.data.signInUserSession.idToken.payload;
                    console.debug(
                        'LOGIN APP. INDEX PAGE. ID TOKEN PAYLOAD',
                        idTokenPayload
                    );

                    const email = idTokenPayload['email'].toLowerCase();
                    getWithEmail(email).then((accounts) => {
                        if (Array.isArray(accounts) && accounts.length > 0) {
                            const account = accounts[0];
                            update(
                                account.id,
                                Object.assign({}, account, {
                                    isAuthorizing: 'no',
                                })
                            ).then((record) => {
                                navigate('/redirect/' + accounts[0].id);
                            });
                        }
                    });
                }
                break;
            case 'signIn_failure':
                break;
            case 'cognitoHostedUI_failure':
                break;
        }
    };

    let authorizing = Cache.getItem('pac-authorizing', {
        callback: () => {
            return 'no';
        },
    });

    Hub.listen('auth', (data) => {
        const { payload } = data;
        onAuthEvent(payload);
    });

    if (authorizing === 'yes') {
        return <AuthorizingIndicator />;
    }

    return <Navigate to="/accounts" />;
};
